import coreUtils from 'common/src/lib/analytics'

$(function () {
  var url = window.location.href

  if($('#job_thank_you').length > 0 && url.includes('subcategory_id') && url.includes('suburb')) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'custom.event.submitJob' });

    coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'jobpost', eventAction: 'jobpostpending' })

    window.history.replaceState({}, document.title, '/job/' + 'thank_you');
  }

  // AI Concierge: the wizard sends the user to /jobs/router/:id, which redirects here
  // so the same conversion fires in this microsite's GTM, then we continue to the app.
  var $conciergeThankYou = $('#job_thank_you[data-source="ai_concierge"]')

  if ($conciergeThankYou.length > 0) {
    var nextUrl = $conciergeThankYou.data('next-url')
    var redirected = false
    var continueToApp = function () {
      if (redirected || !nextUrl) return
      redirected = true
      window.location.replace(nextUrl)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'custom.event.submitJob', jobSource: 'ai_concierge', eventCallback: continueToApp, eventTimeout: 2000 });
    // Fallback in case GTM is blocked or never calls eventCallback
    setTimeout(continueToApp, 2000)

    try {
      coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'jobpost', eventAction: 'jobpostpending' })
    } catch (e) {}

    window.history.replaceState({}, document.title, '/job/' + 'thank_you');
  }
})